import React from 'react';
import { Home, Inbox, Calendar, CreditCard, Building2, Settings, X, AlertCircle } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
interface SidebarProps {
  isOpen?: boolean;
  onClose?: () => void;
}
export function Sidebar({
  isOpen = true,
  onClose
}: SidebarProps) {
  const location = useLocation();
  const navItems = [{
    icon: Home,
    label: 'Home',
    path: '/'
  }, {
    icon: Inbox,
    label: 'Richieste',
    path: '/richieste',
    badge: 3
  }, {
    icon: Calendar,
    label: 'Pianificazione',
    path: '/pianificazione'
  }, {
    icon: AlertCircle,
    label: 'Segnalazioni',
    path: '/segnalazioni',
    badge: 2
  }];
  const secondaryItems = [{
    icon: CreditCard,
    label: 'Crediti',
    path: '/crediti'
  }, {
    icon: Building2,
    label: 'Profilo Azienda',
    path: '/profilo'
  }, {
    icon: Settings,
    label: 'Impostazioni',
    path: '/impostazioni'
  }];
  const handleLinkClick = () => {
    if (onClose) {
      onClose();
    }
  };
  return <>
      {/* Mobile Overlay */}
      {isOpen && onClose && <div className="fixed inset-0 bg-black/50 z-40 lg:hidden" onClick={onClose} data-id="element-383" />}

      {/* Sidebar */}
      <aside className={`
        w-64 bg-white border-r border-gray-200 h-screen fixed left-0 top-0 flex flex-col z-50
        transition-transform duration-300 ease-in-out
        lg:translate-x-0
        ${isOpen ? 'translate-x-0' : '-translate-x-full'}
      `} data-id="element-384">
        {/* Header */}
        <div className="h-16 px-6 border-b border-gray-200 flex items-center justify-between flex-shrink-0" data-id="element-385">
          <img src="https://cdn.magicpatterns.com/uploads/8cgjy9xZXMMnHXpfCScj2x/cleanai_b2b.png" alt="CleanAI B2B" className="h-7" data-id="element-386" />

          {/* Close button - only visible on mobile */}
          {onClose && <button onClick={onClose} className="lg:hidden p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-387">
              <X size={20} className="text-gray-600" data-id="element-388" />
            </button>}
        </div>

        <nav className="flex-1 p-4 overflow-y-auto" data-id="element-389">
          {/* Primary navigation */}
          <ul className="space-y-0.5" data-id="element-390">
            {navItems.map(item => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            return <li key={item.label} data-id="element-391">
                  <Link to={item.path} onClick={handleLinkClick} className={`
                    w-full flex items-center justify-between px-3 py-2.5 rounded-lg transition-colors
                    min-h-[44px]
                    ${isActive ? 'bg-gray-50 text-navy font-medium border border-gray-200' : 'text-gray-600 hover:bg-gray-50 hover:text-navy'}
                  `} data-id="element-392">
                    <div className="flex items-center gap-3" data-id="element-393">
                      <Icon className="w-4 h-4" data-id="element-394" />
                      <span className="font-inter text-sm" data-id="element-395">{item.label}</span>
                    </div>
                    {item.badge && <span className="bg-teal-500 text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full min-w-[18px] text-center" data-id="element-396">
                        {item.badge}
                      </span>}
                  </Link>
                </li>;
          })}
          </ul>

          {/* Divider */}
          <div className="my-4 border-t border-gray-200" data-id="element-397"></div>

          {/* Secondary navigation */}
          <ul className="space-y-0.5" data-id="element-398">
            {secondaryItems.map(item => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            return <li key={item.label} data-id="element-399">
                  <Link to={item.path} onClick={handleLinkClick} className={`
                    w-full flex items-center gap-3 px-3 py-2.5 rounded-lg transition-colors
                    min-h-[44px]
                    ${isActive ? 'bg-gray-50 text-navy font-medium border border-gray-200' : 'text-gray-600 hover:bg-gray-50 hover:text-navy'}
                  `} data-id="element-400">
                    <Icon className="w-4 h-4" data-id="element-401" />
                    <span className="font-inter text-sm" data-id="element-402">{item.label}</span>
                  </Link>
                </li>;
          })}
          </ul>
        </nav>
      </aside>
    </>;
}